export default "__VITE_ASSET__ff8fb3d4__"